type Subscriber<T> = (arg: T) => void

const createSubscriptionManager = <T>() => {
  const subscribers: Subscriber<T>[] = []

  return {
    subscribe: (subscriber: Subscriber<T>) => {
      subscribers.push(subscriber)
    },
    unsubscribe: (subscriber: Subscriber<T>) => {
      const index = subscribers.indexOf(subscriber)
      if (index !== -1) {
        subscribers.splice(index, 1)
      }
    },
    notify: (arg: T) => {
      subscribers.forEach((subscriber) => subscriber(arg))
    },
  }
}

const newTrackManager = createSubscriptionManager<MediaStreamTrack>()
const removedTrackManager = createSubscriptionManager<string>()
const trackChangedManager = createSubscriptionManager<{
  mediaStreamTrack: MediaStreamTrack
  isEnabled: boolean
}>()

const registerOnNewTrackAdded = newTrackManager.subscribe
const registerOnTrackRemoved = removedTrackManager.subscribe
const registerOnTrackChanged = trackChangedManager.subscribe

const removeOnNewTrackAdded = newTrackManager.unsubscribe
const removeOnTrackRemoved = removedTrackManager.unsubscribe
const removeOnTrackChanged = trackChangedManager.unsubscribe

const notifyTrackAdded = newTrackManager.notify
const notifyTrackRemoved = removedTrackManager.notify
const notifyTrackEnabled = (
  mediaStreamTrack: MediaStreamTrack,
  isEnabled: boolean
) => trackChangedManager.notify({ mediaStreamTrack, isEnabled })

export {
  registerOnNewTrackAdded,
  registerOnTrackRemoved,
  registerOnTrackChanged,
  removeOnNewTrackAdded,
  removeOnTrackRemoved,
  removeOnTrackChanged,
  notifyTrackAdded,
  notifyTrackRemoved,
  notifyTrackEnabled,
}
